var appId = window.__RUNTIME_CONFIG__.DSR_SERVER_APPLICATION_ID
var serverUrl = window.__RUNTIME_CONFIG__.DSR_PARSE_SERVER_URL

export default {appId, serverUrl}


//////////////////
// WEBPACK FOOTER
// ./config/parse.js
// module id = axVK
// module chunks = 0